module.exports = __webpack_public_path__ + "static/img/sec2-slide-img02.e5fa149.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hanssem/sec2-slide-img02.png
// module id = 37/M
// module chunks = 0